
export default (configurationGuid) => {
  const {
    nucleusCustomBlindsExperienceBaseUrl,
  } = window.pageContextJavascript;

  return `${nucleusCustomBlindsExperienceBaseUrl}/custom-blinds/configurator/editestimate?configurationGuid=${configurationGuid}`;
};
